module.exports = __webpack_public_path__ + "static/img/2_3_2.8da89e44.jpg";